import { useEffectOnce } from 'react-use';

import { addRequestInterceptor } from '@/shared/api/interceptors';

export const useRequestInterceptor = () => {
  useEffectOnce(() => {
    addRequestInterceptor();
  });
};
